import posthog from "posthog-js";

const POSTHOG_KEY = "phc_mo9MxR6pL3vJLe9GZec28vRF6xqwakexBNrXYMv5jhTZ";
const POSTHOG_HOST = "https://eu.i.posthog.com";

const ADMIN_EMAILS = ["borja@rutment.com", "borjaafanderibera@gmail.com"];

const isLocalhost =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

export function initAnalytics() {
  if (isLocalhost) return;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    autocapture: true,
    capture_pageview: true,
  });
}

export function identifyUser(email) {
  if (isLocalhost || !email) return;
  const normalized = email.toLowerCase().trim();
  if (ADMIN_EMAILS.includes(normalized)) {
    posthog.opt_out_capturing();
    return;
  }
  posthog.opt_in_capturing();
  posthog.identify(normalized);
}

export function resetAnalytics() {
  if (isLocalhost) return;
  posthog.reset();
}

export function track(event, properties) {
  if (isLocalhost) return;
  posthog.capture(event, properties || {});
}
